'use strict';

angular.module('searchUnit')
    .directive('insuranceSearchUnit', insuranceSearchUnit);

function insuranceSearchUnit($location, searchUnitService, sharedSearchUnitService, occupancyService, dateUtil) {
    // Configuration part, mandatory in every searchunit directive with delayed linker
    sharedSearchUnitService.addDelayedLinker(_delayedLinker, 'insuranceSearchUnit');
    return {
        restrict: 'E',
        replace: true,
        scope: {
            areaOverride: '@'
        },
        templateUrl: 'partials/searchunit/insurance',
        controller: 'SharedSearchUnit',
        link(scope, el, attr, controller) {
            return sharedSearchUnitService.initializeArea(scope, el, attr, controller, 'insuranceSearchUnit');
        }
    };

    function _delayedLinker(scope, el, attr, ssu) {
        const mode = sharedSearchUnitService.getAreaInfo(scope.areaOverride).mode;
        scope.model = {};

        scope.policyTypeSelect = policyTypeSelect;
        scope.travelDestinationSelect = travelDestinationSelect;
        scope.search = search;

        // Initialise form
        _restoreSearchCriteria();

        function _restoreSearchCriteria() {
            scope.startDate = searchUnitService.startDate(mode);
            scope.endDate = searchUnitService.endDate(mode);
            scope.travelDestination = searchUnitService.getTravelDestination();
            scope.policyType = searchUnitService.getPolicyType();
            scope.occupancy = [occupancyService.reduceOccupancy()];
        }

        searchUnitService.getPolicyTypes().then((res: any) => {
            scope.policyTypes = res;
        });

        searchUnitService.getTravelDestinations().then((res: any) => {
            scope.travelDestinations = res;
        });

        searchUnitService.getPolicyExtras().then((res: any) => {
            scope.policyExtras = res;
        });

        function travelDestinationSelect() {
            searchUnitService.setTravelDestination(scope.travelDestination);
        }

        function policyTypeSelect() {
            searchUnitService.setPolicyType(scope.policyType);
        }

        function search() {
            //set selected polict extras
            let selectedPolicyExtras: any[] = [];
            scope.policyExtras.forEach(e => {
                if (e.Selected) {
                    selectedPolicyExtras.push({Id : e.Id, Name : e.Name});
                }
            });
            searchUnitService.setPolicyExtra(selectedPolicyExtras);
            //set default end date for annual policy
            if (scope.policyType && scope.policyType.Id === 2) {
                scope.endDate = dateUtil.addDays(scope.startDate, 365, true);
                searchUnitService.endDate(mode, scope.endDate);
            }
            occupancyService.setOccupancy(scope.occupancy);
            ssu.lockScreen('SEARCHINGINSURANCE');
            sharedSearchUnitService.search(undefined, ssu.showErrors, {
                areaOverride: scope.areaOverride
            });
        }
    }
}
